import { Doughnut, mixins } from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['chartData','options', 'textMiddle'],
  mounted () {

    //text in midden van chart zetten voor percentage
    this.addPlugin({
      id: 'percentagedesign',

      beforeDraw: chart => {
        let width = chart.chart.width;
        let height = chart.chart.height;
        let ctx = chart.chart.ctx;

        ctx.restore();
        let fontSize = (height / 80).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        let text = this.textMiddle + "%";
        let textX = Math.round((width - ctx.measureText(text).width) / 2);
        let textY = height / 2;

         ctx.fillText(text, textX, textY);
         ctx.save();
       }
  })
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object

    this.renderChart(this.chartData, this.options, this.textMiddle)
  }
}